<div leaflet style="height: 800px"  [leafletOptions]="options" (leafletMapReady)="onMapReady($event)" (leafletMapMove)="onMapMove($event)" (leafletMapZoom)="onMapZoom($event)">
</div>